module.exports = __webpack_public_path__ + "img/hand.2fd421b3.png";